module.exports = __webpack_public_path__ + "img/2-4.40df8a11.png";